import { IObservable, Subject } from '~/rage/utils';
import {
	IHudHint,
	IHudOffer,
	IHudPlaytimeReward,
	IHudTaskProgress,
} from '~/shared';
import { IDailyTasksService } from '../DailyTasksService';
import { VarsService } from '../VarsService';
import { IHudService } from './hudServiceTypes';

export class HudService implements IHudService {
	private offer = new Subject<IHudOffer | null>(null);
	private isOfferShown = false;

	private hint = new Subject<IHudHint | null>(null);

	private hudTask = new Subject<IHudTaskProgress | null>(null);

	constructor(
		private readonly vars: VarsService,
		private readonly dailyTasks: IDailyTasksService,
	) {
		this.vars.get('hud:offer', null).subscribe((offer: IHudOffer | null) => {
			if (!this.isOfferShown && offer) {
				this.offer.next(offer);
			}
		});

		this.vars.get('hud:hint', null).subscribe((hint: IHudHint | null) => {
			this.hint.next(hint);
		});

		this.dailyTasks.getHudTask().subscribe((task) => {
			this.hudTask.next(task);
		});

		// @TODO quest tasks
	}

	public getOffer(): IObservable<IHudOffer | null> {
		return this.offer;
	}

	public setOfferShown(): void {
		this.isOfferShown = true;
		setTimeout(() => {
			this.offer.next(null);
		}, 300);
	}

	public getHint(): IObservable<IHudHint | null> {
		return this.hint;
	}

	public hideHint(): void {
		this.hint.next(null);
	}

	public getHudTask(): IObservable<IHudTaskProgress | null> {
		return this.hudTask;
	}

	public getPlaytimeReward(): IObservable<IHudPlaytimeReward | null> {
		return this.vars.get('hud:playtimeReward', null);
	}
}
